'use client';
import { styled } from 'styled-components';
import { colors } from '@/styles';

export const LogoImage = styled.img<{ height: number; width: number }>`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
`;

export const LogoPlaceholder = styled.span<{ height: number; width: number }>`
  display: inline-flex;
  font-size: 11px;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  background-color: ${colors.secondary.lightGray2};
  border: 1px solid ${colors.secondary.mediumGray};
  color: ${colors.secondary.mediumGray};
  border-radius: 50%;
`;
